import type { FC } from 'react';
import { useMemo } from 'react';
import { LivePDFPreviewController } from '@features/live-pdf-preview';

import { useRegisterTab } from '../hooks/useRegisterTab';
import type { TabSlotProps } from '../types';

interface LivePDFTabProps extends TabSlotProps {
  documentUrl?: string;
  documentVersion?: number;
  expectedVersion?: number;
  isScanPending?: boolean;
  label: string;
  onDownload: () => Promise<void>;
}

export const LivePDFTab: FC<LivePDFTabProps> = ({
  documentUrl,
  documentVersion,
  expectedVersion,
  id,
  isActive,
  isScanPending,
  label,
  onDownload,
  pageWidth,
  placement,
}) => {
  const registration = useMemo(
    () => ({
      id,
      label,
      fileName: label,
      documentUrl,
      documentVersion,
      onDownload,
    }),
    [id, label, documentUrl, documentVersion, onDownload],
  );

  useRegisterTab(registration);

  if (!isActive) return null;

  return (
    <LivePDFPreviewController
      documentUrl={documentUrl}
      documentVersion={documentVersion}
      expectedVersion={expectedVersion}
      isScanPending={isScanPending}
      onDownload={onDownload}
      pageWidth={pageWidth}
      placement={placement}
    />
  );
};
